/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'seeMore': {
    width: 16,
    height: 16,
    viewBox: '0 0 26 11',
    data: '<g id="首页"><g id="saas-首页无项目" transform="translate(-140 -900)"><g id="icon-more" transform="translate(140 900)"><path pid="0" id="Fill-1" class="st0" d="M5.4 0C2.4 0 0 2.4 0 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4S8.4 0 5.4 0m0 1.4c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4"/><path pid="1" id="Fill-3" class="st0" d="M17.3 9.4c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4M25 6.9c-.3-.2-.8-.1-1 .3-.2.3-.1.8.3 1 .2.1.2.3.1.5s-.3.2-.5.1l-1.7-1c.3-.7.5-1.5.5-2.3 0-3-2.4-5.4-5.4-5.4s-5.4 2.4-5.4 5.4 2.4 5.4 5.4 5.4c1.6 0 3.1-.7 4.1-1.9l1.8 1c.9.5 2 .2 2.5-.7.5-.8.2-1.9-.7-2.4"/><path pid="2" id="Path-4" class="st0" d="M16.1 4.9c-.1.3-.3.4-.6.3-.3-.1-.4-.3-.3-.6.4-1.6 1.7-2.2 3.5-1.9.3 0 .5.3.4.6s-.3.5-.6.4c-1.4-.2-2.1.2-2.4 1.2z"/><path pid="3" id="Path-4-Copy" class="st0" d="M4.1 4.9c-.1.3-.4.4-.6.4-.3-.1-.5-.4-.4-.7.4-1.6 1.7-2.2 3.5-1.9.3 0 .5.3.4.6s-.3.5-.6.5c-1.3-.3-2 .1-2.3 1.1z"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/seeMore.js